import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-formcontrol-error-messages',
    templateUrl: './formcontrol-error-messages.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormcontrolErrorMessagesComponent {

    @Input("forControl") inputFormControl!: FormControl;
/**
 * Certain components are setting themself as dirty by Init, this gives the option to only look at touched.
 */
    @Input("skipDirty") skipdirty = false;

}
